import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../src/assets/styles/scss/style.scss";
import Home from "./pages/Home";
import Loading from "./components/loading/index";

// Pages
import Login from "./views/pages/login/Login";
import Register from "./views/pages/register/Register";
import Page404 from "./views/pages/page404/Page404";
import Page500 from "./views/pages/page500/Page500";
import Protected from "./Protected";
import Users from "./pages/company";
import AddCompanyForm from "./pages/company/companyAddForm";
import PrivacyPolicy from "./views/pages/privacy-policy";
import Terms from "./views/pages/terms";
import RefundPolicy from "./views/pages/refund-policy";
import AboutUs from "./views/pages/about";
import ContactUs from "./views/pages/contact";

const route = () => {

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/privacy-policy" name="Privacy Policy Page" element={<PrivacyPolicy />} />
          <Route exact path="/terms" name="Terms and Condition Page" element={<Terms />} />
          <Route exact path="/refund-policy" name="Refund Policy Page" element={<RefundPolicy />} />
          <Route exact path="/about" name="About Us Page" element={<AboutUs />} />
          <Route exact path="/contact" name="Contact Us Page" element={<ContactUs />} />
          <Route
            exact
            path="/users/userList"
            name="userList"
            element={<Protected Cmp={Users} />}
          />
          <Route
            exact
            path="/users/addform"
            name="addForm"
            element={<Protected Cmp={AddCompanyForm} />}
          />
          <Route
            path="*"
            name="Home"
            element={<Protected Cmp={Home} />}
          ></Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default route;
